import { type ThunkAction, type ThunkDispatch } from "@reduxjs/toolkit";

import { type ReduxState } from "../../types/reduxState";
import { type ThunkExtraArgument } from "../../types/thunk";
import { type DashboardReducerAction } from "../reducers/dashboardReducer";
import { type ErrorReducerAction } from "../reducers/errorReducer";
import { addError } from "./addErrorAction";

type DashboardReducerThunkAction = ThunkAction<
  void,
  ReduxState,
  ThunkExtraArgument,
  DashboardReducerAction
>;

export const onUserIdChange: (
  uid: string | null
) => DashboardReducerThunkAction = (uid: string | null) => {
  return (
    dispatch: ThunkDispatch<
      ReduxState,
      ThunkExtraArgument,
      DashboardReducerAction | ErrorReducerAction
    >,
    getState: () => ReduxState,
    { userApi }: ThunkExtraArgument
  ) => {
    if (!uid) {
      dispatch({ type: "SET_ADMIN_FLAG", userIsAdmin: false });
      return;
    }
    userApi
      .isAdminUser(uid)
      .then((userIsAdmin) => dispatch({ type: "SET_ADMIN_FLAG", userIsAdmin }))
      .catch(addError(dispatch));
  };
};

export const setFeatureFlag: (
  featureFlag: keyof ReduxState["dashboardApp"]["featureFlags"],
  value: boolean
) => DashboardReducerAction = (
  featureFlag: keyof ReduxState["dashboardApp"]["featureFlags"],
  value: boolean
) => ({ type: "SET_FEATURE_FLAG", featureFlag, value });
